<template>
  <a-tooltip
    overlay-class-name="follow-amount-tooltip"
    :visible="visible"
    @visibleChange="visibleChangeFollowAmount($event, item.num)"
  >
    <div
      slot="title"
    >
      <div class="title-wrap clearfix">
        <span
          v-for="(one, i) in overviewAmountData"
          :key="i"
          :data-num="one.key"
          class="amount-title"
          :class="{active: one.active}"
          @mouseenter="enterUnit($event, one)"
        >
          {{ one.name }}
          <i
            v-show="one.active"
            class="amount-unit"
          >{{ one.unit }}</i>
        </span>
      </div>
      <div
        v-show="hover"
        :class="{active: overviewAmountData.length && overviewAmountData.findIndex(item => item.active) !== -1}"
        class="border"
      />
    </div>
    {{ setOverviewNum(item.num) }}
  </a-tooltip>
</template>

<script>
import { formateNumUnit, formatMoney2, fomatFloat } from '@/lib/statistic-utils.js'
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      visible: false,
      hover: false,
      overviewAmountData: []
    }
  },
  methods: {
    visibleChangeFollowAmount (show, num) {
      // num = 10177346712352.6

      if (show) {
        if (!num || num === '0') {
          this.visible = false
          return
        }
        this.visible = true
        let newNum = num.toString()
        if (newNum.indexOf('.') !== -1) {
          let arr = newNum.split('.')
          if (arr[1].length >= 2) {
            newNum = fomatFloat(newNum, 2) // 保留两位小数
          }
        }
        this.setOverviewNumThousands(newNum)
      } else {
        this.visible = false
        this.hover = false
      }
    },
    setOverviewNumThousands (num) {
      let res = formatMoney2(num)
      let arr = []
      // console.log(res)
      let n = 0
      let units = this.$t('message["729"]').split(',')
      let currUnits = []
      if (num.indexOf('.') !== -1) {
        let arr = num.split('.')
        currUnits = units.splice(units.length - arr[0].length, units.length)
        if (arr[1].length === 2) {
          currUnits.push(...this.$t('message["292"]').split(','))
        }
        if (arr[1].length === 1) {
          currUnits.push('分')
        }
      } else {
        currUnits = units.splice(units.length - num.toString().length, units.length)
      }
      // console.log(currUnits)
      for (let i in res) {
        let obj = {
          active: false,
          name: res[i],
          key: '',
          unit: ''
        }
        if (res[i] !== ',' && res[i] !== '.') {
          n++
          obj.key = n
          obj.unit = currUnits[n - 1]
        }
        arr.push(obj)
      }
      this.overviewAmountData = arr
    },
    setOverviewNum (num) {
      // num = 10177346712352.6
      let result = formateNumUnit(num)
      return formatMoney2(result.num) + result.unit
    },
    enterUnit (e, one) {
      // console.log(one)
      this.hover = true
      for (let item of this.overviewAmountData) {
        item.active = false
      }
      if (one.key) {
        one.active = true
      }
    }
  }
}
</script>

<style lang="scss">
.follow-amount-tooltip {
  padding: 0 12px;
  .title-wrap {
    white-space: nowrap;
  }
  .amount-title {
    float: left;
    position: relative;
    padding: 2px 0;
    cursor: pointer;
    color: #666;
  }
  .amount-title.active .amount-unit {
    position: absolute;
    left: -50%;
    top: 36px;
    z-index: 99;
    color: #D6D6D6;
    white-space: nowrap;
    font-style: normal;
    &:after {
      content: "";
      position: absolute;
      top: -8px;
      left: 50%;
      width: 0;
      height: 0;
      margin-left: -7px;
      border-width: 0px 7px 7px 7px;
      border-color: transparent;
      border-bottom-color: #D6D6D6;
      border-style: solid;
    }
    &:before {
      content: "";
      position: absolute;
      top: -6px;
      left: 50%;
      z-index: 2;
      margin-left: -7px;
      width: 0;
      height: 0;
      border-color: transparent;
      border-style: solid;
      border-width: 0px 7px 7px 7px;
      border-bottom-color: #fff;
    }
  }
  .border {
    display: 0;
    margin: 10px 0 20px;
    height: 0;
    border-bottom: solid 1px #D6D6D6;
    &.active {
      opacity: 1;
    }
  }
  .ant-tooltip-inner {
    padding: 12px 20px;
  }
  .ant-tooltip-content {
    &:after {
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      left: 50%;
      margin-left: -7px;
      border-width: 7px 7px 0px 7px;
      border-color: transparent;
      border-top-color: #ebebeb;
      border-style: solid;
    }
  }
  &.ant-tooltip-placement-top {
    .ant-tooltip-arrow {
      bottom: -4px !important;
      z-index: 2;
      border-top-color: #fff !important;
    }
  }
}
</style>
